"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FormContext = void 0;
exports.validationFnNoOps = validationFnNoOps;

var React = _interopRequireWildcard(require("react"));

var _invariant = _interopRequireDefault(require("./utils/invariant"));

var _array = require("./utils/array");

var _formState3 = require("./formState");

var _shapedTree = require("./shapedTree");

var _tree2 = require("./tree");

var _EncodedPath = require("./EncodedPath");

var _feedbackStrategies = _interopRequireDefault(require("./feedbackStrategies"));

var _alwaysValid = _interopRequireDefault(require("./alwaysValid"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// flowlint-next-line unclear-type:off
var noOps = {
  unregister: function unregister() {},
  replace: function replace() {}
}; // noOps can't be used directly because Flow doesn't typecheck a constant as
// being parametric in T.

function validationFnNoOps() {
  return noOps;
}

var FormContext = /*#__PURE__*/React.createContext({
  shouldShowError: function shouldShowError() {
    return true;
  },
  pristine: false,
  submitted: true,
  registerValidation: function registerValidation() {
    return {
      replace: function replace() {},
      unregister: function unregister() {}
    };
  },
  applyCustomChangeToTree: function applyCustomChangeToTree(path, formState) {
    return formState;
  },
  applyChangeToNode: function applyChangeToNode(path, formState) {
    return formState;
  }
});
exports.FormContext = FormContext;

function applyExternalErrorsToFormState(externalErrors, formState) {
  var _formState = _slicedToArray(formState, 2),
      value = _formState[0],
      oldTree = _formState[1];

  var tree;

  if (externalErrors !== null) {
    // If keys do not appear, no errors
    tree = (0, _shapedTree.mapShapedTree)(function (_ref) {
      var errors = _ref.errors,
          meta = _ref.meta;
      return {
        errors: _objectSpread(_objectSpread({}, errors), {}, {
          external: []
        }),
        meta: meta
      };
    }, oldTree);
    Object.keys(externalErrors).forEach(function (key) {
      var newErrors = externalErrors[key];
      var path = (0, _shapedTree.shapePath)(value, (0, _tree2.pathFromPathString)(key));

      if (path != null) {
        // TODO(zach): make some helper functions that do this
        tree = (0, _shapedTree.updateAtPath)(path, function (_ref2) {
          var errors = _ref2.errors,
              meta = _ref2.meta;
          return {
            errors: _objectSpread(_objectSpread({}, errors), {}, {
              external: newErrors
            }),
            meta: meta
          };
        }, tree);
      } else {
        var valueStr = JSON.stringify(value);

        if (valueStr === undefined) {
          valueStr = "undefined";
        }

        console.error("Warning: couldn't match error with path ".concat(key, " to value ").concat(valueStr));
      }
    });
  } else {
    tree = (0, _shapedTree.mapShapedTree)(function (_ref3) {
      var errors = _ref3.errors,
          meta = _ref3.meta;
      return {
        errors: _objectSpread(_objectSpread({}, errors), {}, {
          external: []
        }),
        meta: meta
      };
    }, oldTree);
  }

  return [value, tree];
}

function getValueAtPath(path, value) {
  if (path.length === 0) {
    return value;
  }

  var _path = _toArray(path),
      p = _path[0],
      rest = _path.slice(1);

  if (p.type === "array") {
    (0, _invariant["default"])(Array.isArray(value), "Path/value shape mismatch: expected array");
    return getValueAtPath(rest, value[p.index]);
  } else if (p.type === "object") {
    (0, _invariant["default"])(_typeof(value) === "object" && value !== null && !Array.isArray(value), "Path/value shape mismatch: expected object");
    return getValueAtPath(rest, value[p.key]);
  }

  throw new Error("Path is too long");
}

function pathSegmentEqual(a, b) {
  return a.type === "array" && b.type === "array" && a.index === b.index || a.type === "object" && b.type === "object" && a.key === b.key;
}

function getRelativePath(path, prefix) {
  for (var i = 0; i < prefix.length; i++) {
    (0, _invariant["default"])(pathSegmentEqual(path[i], prefix[i]), "Expect prefix to be a prefix of path");
  }

  return path.slice(prefix.length);
}
/**
 * Deeply validates a FormState tree. Importantly, doesn't set changed metadata:
 * that is the responsibility of the caller.
 */


function validateTree(prefix, _ref4, validations) {
  var _ref5 = _slicedToArray(_ref4, 2),
      value = _ref5[0],
      tree = _ref5[1];

  // TODO(dmnd): Remove the type declarations once [this flow bug][1] is fixed.
  // [1]: https://github.com/facebook/flow/issues/7881
  var entries = _toConsumableArray(validations.entries());

  var newErrors = entries.filter(function (_ref6) {
    var _ref7 = _slicedToArray(_ref6, 1),
        path = _ref7[0];

    return (0, _EncodedPath.startsWith)(path, (0, _EncodedPath.encodePath)(prefix));
  }).map(function (_ref8) {
    var _ref9 = _slicedToArray(_ref8, 2),
        path = _ref9[0],
        validationsMap = _ref9[1];

    // Note that value is not the root value, it's the value at this path.
    // So convert absolute validation paths to relative before attempting to
    // pull out the value on which to run them.
    var relativePath = getRelativePath((0, _EncodedPath.decodePath)(path), prefix);
    var valueAtPath = getValueAtPath(relativePath, value); // Run all validation functions on valueAtPath

    var paths = _toConsumableArray(validationsMap.values());

    var errors = paths.reduce(function (errors, validationFn) {
      return errors.concat(validationFn(valueAtPath));
    }, []);
    return [relativePath, errors];
  });
  var validatedTree = newErrors.reduce(function (tree, _ref10) {
    var _ref11 = _slicedToArray(_ref10, 2),
        path = _ref11[0],
        newErrors = _ref11[1];

    return (// Here we don't reset `errors: {external}` or set `meta: {touched: true,
      // changed: true}`. This is the responsibility of the caller.
      (0, _shapedTree.updateAtPath)(path, function (_ref12) {
        var errors = _ref12.errors,
            meta = _ref12.meta;
        return {
          errors: _objectSpread(_objectSpread({}, errors), {}, {
            client: newErrors
          }),
          meta: _objectSpread(_objectSpread({}, meta), {}, {
            succeeded: meta.succeeded || newErrors.length === 0
          })
        };
      }, tree)
    );
  }, tree);
  return [value, validatedTree];
}
/**
 * In response to a custom change, remove all validation functions from the
 * tree.
 *
 * Note this does not remove validation functions at prefix itself. Only child
 * paths are removed.
 */


function removeDescendantValidations(prefix, validations) {
  var newValidations = new Map(validations);

  var paths = _toConsumableArray(newValidations.keys()).filter(function (path) {
    return (0, _EncodedPath.startsWith)(path, (0, _EncodedPath.encodePath)(prefix)) && path !== (0, _EncodedPath.encodePath)(prefix);
  });

  var _iterator = _createForOfIteratorHelper(paths),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _path2 = _step.value;
      newValidations.set(_path2, new Map());
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return newValidations;
} // Unique id for each field so that errors can be tracked by the fields that
// produced them. This is necessary because it's possible for multiple fields
// to reference the same link "aliasing".


var _nextFieldId = 0;

function nextFieldId() {
  return _nextFieldId++;
} // TODO(dmnd): This function is confusing to use because pathToValue and
// validations are conceptually "absolute" (i.e. they are defined with respect
// to the root), but valueAtPath is *not* absolute: it's the value deeper in the
// tree, defined respective to pathToValue.


function validateAtPath(pathToValue, valueAtPath, // TODO(dmnd): Better typechecking with ShapedPath?
validations) {
  var map = validations.get((0, _EncodedPath.encodePath)(pathToValue));

  if (!map) {
    return [];
  }

  return _toConsumableArray(map.values()).reduce(function (errors, validationFn) {
    return errors.concat(validationFn(valueAtPath));
  }, []);
}
/**
 * Updates the FormState tree to reflect a new value:
 *  - run validations at path (but not child paths)
 *  - remove existing, now obsolete errors
 *  - calculate & write new client side errors
 *  - ensure that meta reflects that the value has changed
 */


function _applyChangeToNode(path, _ref13, validations) {
  var _ref14 = _slicedToArray(_ref13, 2),
      value = _ref14[0],
      tree = _ref14[1];

  var errors = validateAtPath(path, value, validations);
  return [value, (0, _shapedTree.mapRoot)(function (_ref15) {
    var meta = _ref15.meta;
    return {
      errors: {
        client: errors,
        external: "unchecked"
      },
      meta: _objectSpread(_objectSpread({}, meta), {}, {
        succeeded: meta.succeeded || errors.length === 0,
        touched: true,
        changed: true
      })
    };
  }, tree)];
}

var Form = /*#__PURE__*/function (_React$Component) {
  _inherits(Form, _React$Component);

  var _super = _createSuper(Form);

  function Form(props) {
    var _this;

    _classCallCheck(this, Form);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "validations", void 0);

    _defineProperty(_assertThisInitialized(_this), "initialValidationComplete", false);

    _defineProperty(_assertThisInitialized(_this), "pendingValidationPath", null);

    _defineProperty(_assertThisInitialized(_this), "_handleSubmit", function (extraData) {
      _this.setState({
        submitted: true
      });

      var formState = _this.state.formState;
      var tips = {
        valid: {
          client: (0, _formState3.isValid)(formState),
          external: (0, _formState3.isExternallyValid)(formState)
        }
      };

      _this.props.onSubmit(_this.state.formState[0], extraData, tips);
    });

    _defineProperty(_assertThisInitialized(_this), "_handleChange", function (newState) {
      _this.setState({
        formState: newState,
        pristine: false
      }, function () {
        if (_this.pendingValidationPath !== null) {
          _this.recomputeErrorsAtPathAndRender(_this.pendingValidationPath);

          _this.pendingValidationPath = null;
        }
      });

      _this.props.onChange(newState[0]); // Don't call onValidation if there's still a pending validation, because it
      // would be too early: isValid(...) is erroneously true at this time,
      // because:
      //   (a) there are no validations functions
      //   (b) the formState was just created anew
      //
      // Instead, onValidation will be called by the consumer of
      // pendingValidationPath (which is a few lines above, via
      // recomputeErrorsAtPathAndRender).


      if (_this.pendingValidationPath === null) {
        _this.props.onValidation((0, _formState3.isValid)(newState));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_handleBlur", function (newTree) {
      _this.setState({
        formState: [_this.state.formState[0], newTree]
      });
    });

    _defineProperty(_assertThisInitialized(_this), "recomputeErrorsAtPathAndRender", function (path) {
      _this.setState(function (_ref16) {
        var _ref16$formState = _slicedToArray(_ref16.formState, 2),
            rootValue = _ref16$formState[0],
            tree = _ref16$formState[1];

        var value = getValueAtPath(path, rootValue);
        var errors = validateAtPath(path, value, _this.validations); // TODO(dmnd): succeeded isn't set here, that's probably a bug

        var updatedTree = (0, _shapedTree.updateAtPath)(path, function (extras) {
          return _objectSpread(_objectSpread({}, extras), {}, {
            errors: _objectSpread(_objectSpread({}, extras.errors), {}, {
              client: errors
            })
          });
        }, tree);
        var formState = [rootValue, updatedTree];

        _this.props.onValidation((0, _formState3.isValid)(formState));

        return {
          formState: formState
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleRegisterValidation", function (path, fn) {
      // NodeT is for the benefit of callers only. Internally we have no idea what
      // type it is, so cast it to mixed for storage.
      // flowlint-next-line unclear-type:off
      var castedFn = fn;
      var encodedPath = (0, _EncodedPath.encodePath)(path);
      var fieldId = nextFieldId();
      var map = _this.validations.get(encodedPath) || new Map();
      map.set(fieldId, castedFn);

      _this.validations.set(encodedPath, map);

      if (_this.initialValidationComplete) {
        // Form validates all Fields at once during mount. When fields are added
        // after the Form has already mounted, their initial values need to be
        // validated.
        _this.recomputeErrorsAtPathAndRender(path);
      }

      return {
        replace: function replace(fn) {
          return _this.replaceValidation(path, fieldId, fn);
        },
        unregister: function unregister() {
          return _this.unregisterValidation(path, fieldId);
        }
      };
    });

    _defineProperty(_assertThisInitialized(_this), "replaceValidation", function (path, fieldId, fn) {
      // NodeT is for the benefit of callers only. Internally we have no idea what
      // type it is, so cast it to mixed for storage.
      // flowlint-next-line unclear-type:off
      var castedFn = fn;
      var encodedPath = (0, _EncodedPath.encodePath)(path);

      var map = _this.validations.get(encodedPath);

      (0, _invariant["default"])(map != null, "Expected to find handler map");

      var oldFn = map.get(fieldId) || _alwaysValid["default"]; // bail out if the validation function didn't change.


      if (oldFn === fn) {
        return;
      }

      map.set(fieldId, castedFn); // Now that the old validation is gone, make sure there are no left over
      // errors from it.

      var value = getValueAtPath(path, _this.state.formState[0]);

      if ((0, _array.equals)(oldFn(value), castedFn(value))) {
        // The errors haven't changed, so don't bother calling setState.
        // You might think this is a silly performance optimization but actually
        // we need this for annoying React reasons:
        // If the validation function is an inline function, its identity changes
        // every render. This means replaceValidation gets called every time
        // componentDidUpdate runs (i.e. each render). Then when setState is
        // called from recomputeErrorsAtPathAndRender, it'll cause another render,
        // which causes another componentDidUpdate, and so on. So, take care to
        // avoid an infinite loop by returning early here.
        return;
      } // The new validation function returns different errors, so re-render.


      _this.recomputeErrorsAtPathAndRender(path);
    });

    _defineProperty(_assertThisInitialized(_this), "unregisterValidation", function (path, fieldId) {
      var encodedPath = (0, _EncodedPath.encodePath)(path);

      var map = _this.validations.get(encodedPath);

      (0, _invariant["default"])(map != null, "Couldn't find handler map during unregister");
      map["delete"](fieldId); // If the entire path was deleted from the tree, any left over errors are
      // already gone. For example, this happens when an array child is removed.

      if (!(0, _shapedTree.pathExistsInTree)(path, _this.state.formState[1])) {
        return;
      } // now that the validation is gone, make sure there are no left over
      // errors from it


      _this.recomputeErrorsAtPathAndRender(path);
    });

    _this.validations = new Map();

    var _formState2 = applyExternalErrorsToFormState(props.externalErrors, (0, _formState3.freshFormState)(props.initialValue));

    _this.state = {
      formState: _formState2,
      pristine: true,
      submitted: false,
      oldExternalErrors: props.externalErrors
    };
    return _this;
  }

  _createClass(Form, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // After the the Form mounts, all validations get ran as a batch. Note that
      // this is different from how initial validations get run on all
      // subsequently mounted Fields. When a Field is mounted after the Form, its
      // validation gets run individually.
      // TODO(dmnd): It'd be nice to consolidate validation to a single code path.
      // Take care to use an updater to avoid clobbering changes from fields that
      // call onChange during cDM.
      this.setState(function (_ref17) {
        var formState = _ref17.formState;
        return {
          formState: validateTree([], formState, _this2.validations)
        };
      }, function () {
        _this2.initialValidationComplete = true;

        _this2.props.onValidation((0, _formState3.isValid)(_this2.state.formState));
      });
    } // Public API: submit from the outside

  }, {
    key: "submit",
    value: function submit(extraData) {
      this._handleSubmit(extraData);
    } // private

  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var formState = this.state.formState;
      var metaForm = {
        pristine: this.state.pristine,
        submitted: this.state.submitted
      };
      return /*#__PURE__*/React.createElement(FormContext.Provider, {
        value: _objectSpread({
          shouldShowError: this.props.feedbackStrategy.bind(null, metaForm),
          registerValidation: this.handleRegisterValidation,
          applyCustomChangeToTree: function applyCustomChangeToTree(path, _ref18) {
            var _ref19 = _slicedToArray(_ref18, 2),
                value = _ref19[0],
                _tree = _ref19[1];

            _this3.validations = removeDescendantValidations(path, _this3.validations);
            var pendingValidationPath = _this3.pendingValidationPath;

            if (pendingValidationPath == null) {
              _this3.pendingValidationPath = path;
              return (0, _formState3.changedFormState)(value);
            } // If we haven't returned, there is an existing path waiting for
            // validation. There could have been nested custom changes, in which
            // case it's safe to discard the child path, because validating the
            // parent path will take care of the child path too.


            var encodedPath = (0, _EncodedPath.encodePath)(path);
            var encodedPendingPath = (0, _EncodedPath.encodePath)(pendingValidationPath);

            if ((0, _EncodedPath.startsWith)(encodedPath, encodedPendingPath)) {
              _this3.pendingValidationPath = pendingValidationPath; // noop

              return (0, _formState3.changedFormState)(value);
            } else if ((0, _EncodedPath.startsWith)(encodedPendingPath, encodedPath)) {
              _this3.pendingValidationPath = path;
              return (0, _formState3.changedFormState)(value);
            } // If we still haven't returned, the pending validation path is a
            // sibling of the new path. We haven't though through what to do in
            // this case, so just error for now.
            // TODO(dmnd): pendingValidationPath could be a queue, or perhaps we
            // only care about the most recent value, but right now it's unclear
            // what should happen because the formState and validation map has
            // potentially transitioned through multiple unvalidated shapes.


            (0, _invariant["default"])(false, "Unexpected pending validation. Consecutive customChanges are not supported. If you think you have a valid use case, please contact us!");
          },
          applyChangeToNode: function applyChangeToNode(path, formState) {
            return _applyChangeToNode(path, formState, _this3.validations);
          }
        }, metaForm)
      }, this.props.children({
        formState: formState,
        onChange: this._handleChange,
        onBlur: this._handleBlur,
        path: []
      }, this._handleSubmit, {
        touched: (0, _formState3.getExtras)(formState).meta.touched,
        changed: (0, _formState3.getExtras)(formState).meta.changed,
        blurred: (0, _formState3.getExtras)(formState).meta.blurred,
        shouldShowErrors: this.props.feedbackStrategy(metaForm, (0, _formState3.getExtras)(formState).meta),
        unfilteredErrors: (0, _formState3.flatRootErrors)(formState),
        asyncValidationInFlight: false,
        // no validations on Form
        valid: (0, _formState3.isValid)(formState),
        value: formState[0]
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (props.externalErrors !== state.oldExternalErrors) {
        var newTree = applyExternalErrorsToFormState(props.externalErrors, state.formState);
        return {
          formState: newTree,
          oldExternalErrors: props.externalErrors
        };
      }

      return null;
    }
  }]);

  return Form;
}(React.Component);

exports["default"] = Form;

_defineProperty(Form, "defaultProps", {
  onChange: function onChange() {},
  onSubmit: function onSubmit() {},
  onValidation: function onValidation() {},
  feedbackStrategy: _feedbackStrategies["default"].Always,
  externalErrors: null
});